import ApiService from '@/services/api'
import { defineStore } from 'pinia'

const ENDPOINT = '/projectversions/'
const ITEM_ID  = 'prv_id'

export const useProjectVersionStore = defineStore('projectversions', {
  state: () => ({
    item: null,
    itemList: [],
    metaItems: null
  }),
  getters: {
    itemListByProject () {
      let itemsObject = {}
      for (let i = 0, len = this.itemList.length; i < len; i++) {
        const pro = this.itemList[i].prv_pro_id
        if (!itemsObject[pro]) { itemsObject[pro] = [] }
        itemsObject[pro].push(this.itemList[i])
      }
      return itemsObject
    },
    itemListByType () {
      let itemsObject = {}
      for (let i = 0, len = this.itemList.length; i < len; i++) {
        const typ = this.itemList[i].prv_typ_id
        // on ne garde que le premier item rencontré pour chaque type
        if (!itemsObject[typ]) { itemsObject[typ] = this.itemList[i] }
      }
      return itemsObject
    }
  },
  actions: {
    fetchItem (id, options) {
      return new Promise((resolve, reject) => {
        options = (options) ? '/' + options : ''
        if (id && id > 0) {
          ApiService.get(ENDPOINT + id + options).then((response) => {
            this.SET_ITEM(response.data.data)
            resolve(this.item)
          }).catch((error) => { reject(error) })
        } else {
          this.RESET_ITEM()
          resolve(this.item)
        }
      })
    },
    fetchItems (options) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + (options || '')).then((response) => {
          this.metaItems = response.data.meta
          if (Object.prototype.toString.call(response.data.data) === '[object Array]') {
            this.SET_ITEMS(response.data.data)
          }
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    getGeoJson (id) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + id + '/geojson').then((response) => {
          resolve(response.data)
        }).catch((error) => { reject(error) })
      })
    },
    storeItem () {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT, this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateItem () {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + this.item[ITEM_ID], this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateFile (id, data) {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT + id, data).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    getShapeFields (id, data) {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT + id + '/getfields', data).then((response) => {
          resolve(response.data)
        }).catch((error) => { reject(error) })
      })
    },
    destroyItem (id) {
      return new Promise((resolve, reject) => {
        this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
        ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then(() => {
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) { this.item = item },
    SET_ITEMS (itemList) { this.itemList = itemList },
    RESET_ITEM () { this.item = {} }
  }
})
